// extracted by mini-css-extract-plugin
export default {"recommendedBookIcon":"RecommendedBooks_recommendedBookIcon__HkLzt","booksCarousel":"RecommendedBooks_booksCarousel__-z9ar"};